/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { getAuthTokens, refreshAuthTokens } from "./auth";

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: getAuthTokens() ? `Bearer ${getAuthTokens().IdToken}` : "",
  },
  paramsSerializer: {
    indexes: null,
  },
});

/**
 * Interceptor to handle 401 responses (Unauthorized) and refresh the tokens
 *
 * @param error
 * @returns
 */
const httpInterceptorOnRejected = async (error: any) => {
  if (error.response?.status === 401 && !error.config._retry) {
    try {
      // Refresh the tokens, in Local Storage and AuthStore
      await refreshAuthTokens();

      // Mark the request for retry
      error.config._retry = true;

      // Update the Authorization header
      error.config.headers.Authorization = `Bearer ${getAuthTokens().IdToken}`;

      // Update the instance defaults
      instance.defaults.headers.Authorization =
        error.config.headers.Authorization;

      // Retry the request
      return await axios.request(error.config);
    } catch (error: any) {
      return Promise.reject(error);
    }
  }

  return Promise.reject(error);
};

instance.interceptors.response.use(
  (response) => response,
  httpInterceptorOnRejected,
);

export default instance;
